import { render } from "./Dropdown.vue?vue&type=template&id=3a50cd72&scoped=true&ts=true"
import script from "./Dropdown.vue?vue&type=script&lang=ts"
export * from "./Dropdown.vue?vue&type=script&lang=ts"

import "./dropdown.scss?vue&type=style&index=0&id=3a50cd72&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a50cd72"]])

export default __exports__